// extracted by mini-css-extract-plugin
export default {"wrapper":"MapPOIS_wrapper__yIv7W","map_title_style":"MapPOIS_map_title_style__NiwMb"};